'use client';

import { useEffect, useState } from 'react';

import { getFooterLinks } from '@/features/cms/actions/footerActions';

import { FooterLinks as FooterLinksComponent } from '@/features/cms/components/footer/FooterLinks';

const FooterLinks = () => {
  const [sections, setSections] = useState<Array<{
    title: string;
    links: Array<{
      title: string;
      href: string;
      external?: boolean;
    }>;
  }>>([]);

  useEffect(() => {
    getFooterLinks().then(setSections);
  }, []);

  return <FooterLinksComponent sections={sections} />;
};

export default FooterLinks;
